import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { LOCATIONS_TREE_QUERY } from 'graphql/locations/queries'
// types
import { TRefetch } from 'types/refetch'
import { NetworkStatus } from '@apollo/client'
import { ILocation, ILocationsResponse, ILocationsQueryArgs } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOr, maxBy, pipe } from 'lodash/fp'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  locations: ILocationsResponse
}

interface Context {
  refetch: TRefetch<QueryResponse, ILocationsQueryArgs>
  locations: ILocation[]
  isLoading: boolean
  lastPosition: number
}

export const LocationAPIContext = React.createContext<Context>({} as any)

const LocationsAPI: React.FC<Props> = ({ children }) => {
  const {
    data: treeQuery,
    refetch,
    loading,
    networkStatus
  } = useQuery<QueryResponse, ILocationsQueryArgs>(LOCATIONS_TREE_QUERY, {
    variables: {
      pagination: {
        pageSkip: 0,
        pageTake: 10000
      }
    }
  })

  const locations: ILocation[] = (get(treeQuery, 'locations.data') || []).map((locations) => ({
    ...locations,
    title: locations.description
  }))

  const lastPosition: number = pipe<any, any, any>(maxBy('position'), getOr(0, 'position'))(locations)

  const value = {
    refetch,
    locations,
    lastPosition,
    isLoading: loading && networkStatus === NetworkStatus.loading
  }

  return <LocationAPIContext.Provider value={value}>{children}</LocationAPIContext.Provider>
}

export default LocationsAPI
